<template>
  <Popper placement="left">
    <component :is="MODALS_DATA[pageType].button" />
    <template #content="{ close }">
      <div class="modal">
        <component :is="MODALS_DATA[pageType].title" />
        <div class="modal__body">
          <component
            :is="MODALS_DATA[pageType].body"
            :item="item"
            @closeModal="close"
          />
        </div>
      </div>
    </template>
  </Popper>
</template>

<script>
import { defineComponent } from 'vue';
import { MODALS_DATA } from '@/components/popup/commonModals';

import Popper from 'vue3-popper';
import useModalData from '@/composables/useModalData';

export default defineComponent({
  name: 'CommonModal',
  components: { Popper },
  props: {
    item: { type: Object },
  },
  setup() {
    const { pageType } = useModalData();
    return { pageType };
  },
  data() {
    return {
      MODALS_DATA,
    };
  },
});
</script>
